import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import TranslationService from '../utils/translationService';

/**
 * Smart TranslatedText component (mirroring mobile app TranslatedText)
 * Automatically translates dynamic server text to the current selected language.
 *
 * Usage:
 * <TranslatedText>{item.title}</TranslatedText>
 * <TranslatedText component="h3" className="title-class">{prayer.description}</TranslatedText>
 */
const TranslatedText = ({
  children,
  text,
  component: Component = 'span',
  fallback = null,
  className = '',
  style = {},
  ...props
}) => {
  const { currentLang } = useLanguage();
  const rawInput = text !== undefined && text !== null ? text : children;
  const textContent = typeof rawInput === 'string' ? rawInput : (rawInput != null ? String(rawInput) : '');
  const [translated, setTranslated] = useState(textContent);

  useEffect(() => {
    let isMounted = true;

    if (!textContent || currentLang === 'en') {
      setTranslated(textContent);
      return;
    }

    TranslationService.translate(textContent, currentLang)
      .then((res) => {
        if (isMounted) {
          setTranslated(res || textContent);
        }
      })
      .catch(() => {
        if (isMounted) {
          setTranslated(textContent);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [textContent, currentLang]);

  return (
    <Component className={className} style={style} {...props}>
      {translated != null && translated !== '' ? translated : (fallback || rawInput || '')}
    </Component>
  );
};

export default TranslatedText;
